<template>
  <div style="float: center;">
    <HeaderView/>
  </div >

<!-- 走马灯效果 -->
  <div style="min-width: 1200px;  margin: 0 auto;">
    <el-carousel :interval="4000" arrow="always" height="600px" min-width="1200px"   trigger="click">
      <el-carousel-item v-for="item in imglist" :key="item.id"
      style="float: left"
      display="inline-table"
      >
        <el-image style="width: 100%; height: 100%;min-height: 630;min-width: 1200px;"
          :src="item.imageSrc"
          fit="fill" 
          >
          </el-image> 
      </el-carousel-item>
    </el-carousel>
  </div>
  <div style="width: 1200px;  margin: 0 auto;">
    <p class="zt">关于我们</p>
    <p class="zt1">ABOUT US</p>
    <div> 我们是一家综合性医药批发、物流商业公司</div>
    <el-divider />
    <div style="float: left;margin: 0 30px  40px  50px;">
      <el-image style="width: 60%; height: 60%;float: left;margin-right: 20px ;"
          :src="img_office"
          >
          </el-image> 
          <div class="p2">
            <p>&ensp;&ensp;&ensp;&ensp;温州市新光医药有限公司成立于于2003年4月30日，位于温州市瓯海区，是一家综合性医药批发公司。</p>
            <p>&ensp;&ensp;&ensp;&ensp;企业从立业之初便是以民生关怀、承载社会责任、传承国医药文化为核心价值的企业以“品质保证、服务专业、
            客户满意”为经营宗旨，以提倡......</p>
          </div>
          <div style="margin:20px 0 0 50px;float: left;">
            <el-button type="primary" plain  @click="A111">查看更多</el-button>
            <el-button type="info" plain  @click="A151" >联系我们</el-button>
          </div>
    </div>

    <!-- 经营范围 -->
    <div >
      <p class="zt" >经营范围</p>
      <el-divider />
      <br>
      <el-row :gutter="100" justify="center">
        <el-col :span="4">
          <el-image class="images" :src="require('@/assets/cope1.png')" /><br>
          <span>西药</span>
        </el-col>
        <el-col :span="4">
          <el-image class="images"  :src="require('@/assets/cope2.png')"  /><br>
          <span>中成药</span>
        </el-col>
        <el-col :span="4">
          <el-image class="images"  :src="require('@/assets/cope3.png')"  /><br>
          <span>中药饮片</span>
        </el-col>
        <el-col :span="4">
          <el-image class="images"  :src="require('@/assets/cope7.png')"  /><br>
          <span>中药材</span>
        </el-col>
        <el-col :span="4">
          <el-image class="images"  :src="require('@/assets/cope8.png')"  /><br>
          <span>生物制品</span>
        </el-col>
      </el-row>
      <br><br>
      <el-row :gutter="100" justify="center">
        <el-col :span="4">
          <el-image class="images"  :src="require('@/assets/cope9.png')"  /><br>
          <span>医疗器械</span>
        </el-col>
        <el-col :span="4">
          <el-image class="images"  :src="require('@/assets/cope5.png')"  /><br>
          <span>医疗器械</span>
        </el-col>
        <el-col :span="4">
          <el-image class="images"  :src="require('@/assets/cope4.png')"  /><br>
          <span>化学药制剂</span>
        </el-col>
        <el-col :span="4">
          <el-image class="images"  :src="require('@/assets/cope6.png')"  /><br>
          <span>化学原料药</span>
        </el-col>
        <el-col :span="4">
          <el-image class="images"  :src="require('@/assets/cope11.png')"  /><br>
          <span>生化药品</span>
        </el-col>
      </el-row>
    </div>
  </div>
  <br>

  <div >
    <FooterView/>
  </div>
  <!-- 回到顶部 -->
  <el-backtop :right="60" :bottom="100" />
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import HeaderView from '../views/qianduan/HeaderView.vue'
import FooterView from '../views/qianduan/FooterView.vue'


export default {
  name: 'HomeView',
  data() {
      return {
        img_office:require('@/assets/office.jpg'),
        imglist:[
          {id:0,imageSrc:require('@/assets/1-1.png')},
          {id:1,imageSrc:require('@/assets/1-2.jpg')},
          {id:2,imageSrc:require('@/assets/1-3.jpg')}
        ],
      };
    },

  components: {
    HelloWorld,
    HeaderView,
    FooterView,
  },
  methods: { 
    //联系我们
    A151(){
      this.$router.push("/A151");
    },
    //关于我们
    A111(){
      this.$router.push("/A111");
    },
  }
}
</script>


<style scoped>
.button{width: 200px;height:40px;}

.zt{color:cornflowerblue; font-size: 30px;}
.zt1{margin-top: -16px; color:rgb(168, 168, 168);font-size: 12px;}
.p2{ text-align: left;font-size: 18px;margin-top: 0px; line-height:1.5 ;}

.lef{width: 1200px; margin: 0 auto;text-align: left; 
  padding-top: 25px;
}
.left_b{  background-color: #e7e7e7;height: 120px;}

.zht2{float: left;margin-right: 5px;}
.el-row {
  margin-bottom: 20px;
}

.images{width: 140px; height: 140px}

.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}




.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
  text-align: center;

}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #b8b8b8;
}
</style>